// @ts-nocheck

import { useEffect } from 'react';

export const useApplyGtagUser = (userId = null) => {
  useEffect(() => {
    if (!userId || !window?.dataLayer) return;

    window.dataLayer.push({
      event: 'user_id_set',
      user_id: userId,
    });
  }, [userId]);
};
